import React from 'react';
import PulseLoader from 'components/Loading/Pulse';
import { OpcChart } from './OpcChart';
import { type StrategyCalculationData } from './strategyCalculationsCache';

/**
 * Its own module so the Flow table's payoff modal can use the chart without importing
 * OptionsCalculator. That screen pulls in EditorialBody and @markdoc/markdoc, which made `/`
 * and `/flow` load a 140 KB editorial chunk they never render.
 */
export const MemoizedChart = React.memo(
  ({
    payoffGraph,
    maxProfitLoss,
    breakEvenPoints,
    probabilityData,
    spot,
  }: {
    payoffGraph?: StrategyCalculationData['payoffGraph'];
    maxProfitLoss?: StrategyCalculationData['maxProfitLoss'];
    breakEvenPoints?: StrategyCalculationData['breakEvenPoints'];
    probabilityData?: StrategyCalculationData['probabilityData'];
    spot?: StrategyCalculationData['spot'];
  }) => {
    if (!payoffGraph || !maxProfitLoss || !breakEvenPoints || !probabilityData || !spot) {
      return (
        <div className="flex justify-center">
          <PulseLoader />
        </div>
      );
    }

    return (
      <OpcChart
        payoffGraph={payoffGraph}
        maxProfitLoss={maxProfitLoss}
        breakEvenPoints={breakEvenPoints}
        probabilityData={probabilityData}
        spot={spot}
      />
    );
  },
);
